import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {CREDIT_CARD_CATEGORY, newDesignInputCustomClassesViewOnly} from "../../../constants";
import {dateToMoment} from "../../utils";

const CreditCardForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: defaults.sub_category ? String(defaults.sub_category) : null,
    name: defaults.name,
    company: defaults.company,
    value: decimalStrToNumber(defaults.value),
    credit_limit: decimalStrToNumber(defaults.credit_limit),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({...model});
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            label="Kategorie"
            value={model.sub_category}
            options={CREDIT_CARD_CATEGORY.subCategories}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            required
            newDesign
            disabled={viewOnly}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Gesellschaft'}
          value={model.company}
          error={errors.company}
          onChange={handleModelChange('company')}
          dataId={'company_name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Belastungssumme"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          required={!viewOnly}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Kreditlinie"
          inputComponent={CurrencyNumberFormat}
          value={model.credit_limit}
          error={errors.credit_limit}
          onChange={handleModelChange('credit_limit')}
          dataId={'credit_limit-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

CreditCardForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default CreditCardForm;